export const environment = {
  production: true,
  apiUrl: 'https://wellfyt.wellness-svp.cz/api',
  appName: 'Wellfyt',
};
